import React from 'react';
import { Badge } from 'react-bootstrap';
import '../SearchMain.css';

export default function JournalCardView(props) {
  const { searchResult, handleShow, isArticle } = props;

  const renderStatusBadge = (status) => {
    if (status === 'Active' || status === 'Available') {
      return (
        <span className="badge-available">
          <i className="bi bi-check-circle me-1"></i> Available
        </span>
      );
    }
    if (status === 'Issued') {
      return (
        <span className="badge-issued">
          <i className="bi bi-clock me-1"></i> In Use / Issued
        </span>
      );
    }
    return <Badge bg="secondary" className="px-2 py-1">{status || 'Available'}</Badge>;
  };

  if (!searchResult || searchResult.length === 0) {
    return null;
  }

  return (
    <div className="row g-3">
      {searchResult.map((item, index) => {
        if (isArticle) {
          // Article Card
          const callNumber = item.callNo || item.journalCallNo || item.bookClassificationNo || item.classificationNo || '';
          const journalName = item.journalTitle || item.bookTitle || item.sourceJournal || '';

          return (
            <div key={index || item.articleID} className="col-12 col-sm-6 col-md-4 col-lg-3">
              <div
                className="vj-book-card"
                onClick={(e) => handleShow(e, item)}
                title="Click to view complete article and volume details"
              >
                {/* Card Header Banner */}
                <div
                  className="p-3 text-center position-relative"
                  style={{
                    background: 'linear-gradient(135deg, #09475f 0%, #0bb6d7 100%)',
                    color: '#ffffff',
                    minHeight: '100px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div
                    style={{
                      width: '46px',
                      height: '46px',
                      borderRadius: '50%',
                      background: 'rgba(255, 255, 255, 0.2)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '22px',
                    }}
                  >
                    <i className="bi bi-file-earmark-text"></i>
                  </div>
                  {item.volissuesNo && (
                    <div className="position-absolute top-0 end-0 p-2">
                      <span className="badge bg-white text-dark small px-2 py-1">
                        Vol. {item.volissuesNo}
                      </span>
                    </div>
                  )}
                  {(item.journalID || item.articleID) && (
                    <div className="position-absolute top-0 start-0 p-2">
                      <span className="badge bg-dark bg-opacity-50 text-white font-monospace" style={{ fontSize: '0.7rem' }}>
                        #{item.journalID || item.articleID}
                      </span>
                    </div>
                  )}
                </div>

                {/* Card Body */}
                <div className="vj-book-card-body">
                  <div>
                    {callNumber ? (
                      <div className="vj-callno-badge mb-2">
                        <i className="bi bi-geo-alt-fill text-primary"></i> Call No: <strong>{callNumber}</strong>
                      </div>
                    ) : (
                      <div className="vj-callno-badge mb-2">
                        <i className="bi bi-journal-bookmark text-primary"></i> Vol: #{item.journalID || item.articleID}
                      </div>
                    )}

                    <h6 className="vj-article-card-title" title={item.articleTitle}>
                      {item.articleTitle}
                    </h6>

                    {item.articleSubTitle && item.articleSubTitle !== 'NA' && (
                      <div className="small text-muted fst-italic mb-1 text-truncate" title={item.articleSubTitle}>
                        {item.articleSubTitle}
                      </div>
                    )}

                    <div className="vj-article-card-author">
                      <i className="bi bi-person me-1 text-muted"></i>
                      {item.articleAuthor || 'Unknown Author'}
                    </div>

                    {journalName && (
                      <div className="small text-secondary mt-2 pt-1 border-top text-truncate" title={`Host Journal: ${journalName}`}>
                        <i className="bi bi-journal-album text-primary me-1"></i>
                        <strong className="text-dark">Journal:</strong> {journalName}
                      </div>
                    )}
                  </div>

                  <div className="d-flex justify-content-between align-items-center pt-2 border-top mt-2 small text-muted">
                    <span className="text-truncate" style={{ maxWidth: '130px' }} title={item.articleKeywords || 'Scholarly Article'}>
                      <i className="bi bi-tag me-1"></i> {item.articleKeywords || 'Article'}
                    </span>
                    <span className="font-monospace text-primary fw-bold">
                      {item.startPageNo && item.endPageNo
                        ? `pp. ${item.startPageNo}-${item.endPageNo}`
                        : item.startPageNo
                        ? `p. ${item.startPageNo}`
                        : (item.volissuesNo ? `Vol. ${item.volissuesNo}` : 'Article')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        // Journal Card
        const isBoundJournal = (item.journalType || '').trim().toLowerCase() === 'bound journal';

        return (
          <div key={item.journalID || index} className="col-12 col-sm-6 col-md-4 col-lg-3">
            <div
              className="vj-book-card"
              onClick={(e) => handleShow(e, item)}
              title="Click to view journal issues, rack location, and details"
            >
              {/* Card Header Banner */}
              <div
                className="p-3 text-center position-relative"
                style={{
                  background: isBoundJournal
                    ? 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)'
                    : 'linear-gradient(135deg, #063547 0%, #0bb6d7 100%)',
                  color: '#ffffff',
                  minHeight: '110px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {isBoundJournal && (
                  <div className="position-absolute top-0 start-0 p-2">
                    <span className="badge-bound-journal shadow-sm" style={{ background: 'rgba(255, 255, 255, 0.25)', border: '1px solid rgba(255, 255, 255, 0.4)' }}>
                      <i className="bi bi-journal-bookmark-fill me-1"></i> Bound Journal
                    </span>
                  </div>
                )}
                <div
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    background: 'rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                  }}
                >
                  <i className={isBoundJournal ? 'bi bi-journal-bookmark-fill' : 'bi bi-journal-album'}></i>
                </div>
                <div className="position-absolute top-0 end-0 p-2">
                  {renderStatusBadge(item.journalStatus)}
                </div>
              </div>

              {/* Card Body */}
              <div className="vj-book-card-body">
                <div>
                  <div className="d-flex align-items-center flex-wrap gap-1 mb-2">
                    <div className="vj-callno-badge">
                      <i className="bi bi-geo-alt-fill text-danger"></i> {item.liblocation || 'Periodicals Section'}
                    </div>
                    {isBoundJournal && (
                      <span className="badge-bound-journal-subtle">
                        <i className="bi bi-journal-bookmark-fill me-1"></i> Bound Journal
                      </span>
                    )}
                  </div>

                  <h6 className="vj-journal-card-title" title={item.journalTitle}>
                    {item.journalTitle}
                  </h6>

                  {item.publisher && item.publisher !== 'NA' && (
                    <div className="vj-journal-card-publisher">
                      <i className="bi bi-building me-1 text-muted"></i>
                      {item.publisher}
                    </div>
                  )}
                </div>

                <div className="d-flex justify-content-between align-items-center pt-2 border-top mt-2 small text-muted">
                  <div className="d-flex align-items-center gap-1">
                    <span className="badge bg-light text-dark border">
                      {item.frequency || item.journalSubject || 'Periodical'}
                    </span>
                    {isBoundJournal && (
                      <span className="badge-bound-journal" style={{ fontSize: '0.68rem', padding: '2px 6px' }}>
                        Bound
                      </span>
                    )}
                  </div>
                  <span className="font-monospace fw-bold text-primary">
                    #{item.journalID}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
